import TextareaAutosize from 'react-textarea-autosize';
import { isLockedWidget } from '@/components/forms/utils/links';
import { WidgetWriterProps } from '../widget.type';
import { cn } from '@/shadcn/lib/utils';
import { TestId } from '@/types/testId';

export const TextArea = ({
  id,
  value = '',
  name,
  placeholder,
  required = false,
  disabled = false,
  onChange = () => {},
  invalid = false,
  formContext,
  label,
  schema,
  uiSchema
}: WidgetWriterProps) => {
  const isLocked = isLockedWidget(id, formContext?.links);

  return (
    <TextareaAutosize
      id={id}
      value={value}
      placeholder={placeholder || 'Aa'}
      disabled={disabled || isLocked}
      onChange={event => onChange(event.target.value)}
      required={required}
      aria-invalid={invalid}
      aria-label={label}
      data-testid={TestId.FormWriter.TextArea}
      className={cn(
        'bg-muted dark:bg-accent placeholder:text-muted-foreground border-input focus-visible:ring-ring focus-visible:ring-offset-card min-h-20 w-full rounded-md border px-3 py-2 text-base focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        invalid && 'border-destructive focus-visible:ring-destructive/70'
      )}
      data-cy={`textarea-${name}`}
      maxLength={schema.maxLength}
      minLength={schema.minLength}
      autoFocus={uiSchema?.['ui:autofocus'] as boolean | undefined}
    />
  );
};
